import { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { useInViewOnce } from '../../hooks/useInViewOnce';

const FAQs = lazy(() => import('./FAQs'));

/** Defers FAQ section chunk until the user scrolls near it (below the fold on homepage). */
export default function DeferredHomepageFaqs() {
  const anchorRef = useRef<HTMLElement>(null);
  const nearViewport = useInViewOnce(anchorRef, { once: true, margin: '240px' });
  const [showFaqs, setShowFaqs] = useState(() => typeof window === 'undefined');

  useEffect(() => {
    if (nearViewport) setShowFaqs(true);
  }, [nearViewport]);

  return (
    <section ref={anchorRef} className="deferred-homepage-faqs" aria-busy={!showFaqs}>
      {showFaqs ? (
        <Suspense fallback={<div className="faqs-section faqs-section--placeholder" aria-hidden="true" />}>
          <FAQs />
        </Suspense>
      ) : (
        <div className="faqs-section faqs-section--placeholder" aria-hidden="true" />
      )}
    </section>
  );
}

